import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import axios from "axios";
import { API, getToken, clearToken, authHeaders } from "@/lib/api";
import { PasswordGate } from "@/components/PasswordGate";
import { Header } from "@/components/Header";
import { KineticHero } from "@/components/KineticHero";
import { Marquee } from "@/components/Marquee";
import { GalleryGrid } from "@/components/GalleryGrid";
import { AboutSection } from "@/components/AboutSection";
import { ContactSection } from "@/components/ContactSection";
import { Footer } from "@/components/Footer";
import { Monogram } from "@/components/Monogram";

export default function VaultPage() {
  const [unlocked, setUnlocked] = useState(null);

  useEffect(() => {
    const check = async () => {
      if (!getToken()) {
        setUnlocked(false);
        return;
      }
      try {
        await axios.get(`${API}/gate/check`, { headers: authHeaders() });
        setUnlocked(true);
      } catch {
        clearToken();
        setUnlocked(false);
      }
    };
    check();
  }, []);

  if (unlocked === null) {
    return (
      <div className="flex h-screen items-center justify-center bg-[#FAFAF7] text-[#B08D2E]">
        <motion.div animate={{ opacity: [0.4, 1, 0.4] }} transition={{ duration: 2, repeat: Infinity }}>
          <Monogram size={56} />
        </motion.div>
      </div>
    );
  }

  return (
    <>
      <div className="grain-overlay" />
      <AnimatePresence mode="wait">
        {!unlocked ? (
          <PasswordGate key="gate" onUnlock={() => setUnlocked(true)} />
        ) : (
          <motion.main
            key="vault"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
          >
            <Header />
            <KineticHero />
            <Marquee />
            <GalleryGrid />
            <AboutSection />
            <div className="gold-hairline mx-auto w-2/3" />
            <ContactSection />
            <Footer />
          </motion.main>
        )}
      </AnimatePresence>
    </>
  );
}
